<template>
  <div class="container">
    <blog-header :heading-text="page.title" :html-string="page.template.introductie || ''"/>
    <filter-bar-blogs @new-query="newQuery"/>
    <section v-if="!$apollo.loading" class="flex flex-wrap">
      <header class="w-full h2 text-secondary pb-8">Blogs</header>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 w-full mb-8">
        <div v-if="!blogs.data.length">Geen resultaten gevonden</div>
        <blog-item v-for="blog in blogs.data" :key="blog.id" :blog="blog"/>
      </div>
      <pagination v-if="blogs.data.length" v-model="p" :last-page="blogs.last_page" :current-page="p"/>
    </section>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FilterBarBlogs from '~/components/blog/FilterBarBlogs';
import BlogItem from '~/components/blog/BlogItem';
import blogs from '~/graphql/queries/blogs';
import pagination from '~/components/base/Pagination';
import BlogHeader from '~/components/fullwidth-blocks/BlogHeader';
import page from '~/plugins/mixins/page';

export default {
  components: {BlogHeader, BlogItem, FilterBarBlogs, pagination},
  mixins: [page],
  layout: 'blog',
  data: () => ({
    p: 1,
    limit: 8,
    q: null,
    month: null,
    year: null,
  }),
  apollo: {
    blogs: {
      query: blogs,
      variables() {
        return {
          limit: this.limit,
          page: this.p,
          q: this.q,
          month: this.month,
          year: this.year,
        };
      },
    },
  },
  methods: {
    newQuery: debounce(function ({month, year, q}) {
      this.p = 1;
      this.limit = 8;
      this.q = q;
      this.month = month;
      this.year = year;
    }, 500),
  },
};
</script>
